import React, { useCallback, useEffect, useState } from 'react'
import Dialog from '../../../../dialog/Dialog'
import { useDispatch, useSelector } from 'react-redux';
import { updateClassPreview, updateClassForm } from '../../../../../store/actions/class.actions';
import { getClassById } from '../../../../../services/classes/classes.service';
import ClassSkeleton from '../../../../skeleton/ClassSkeleton';
import { handlerErrorV2 } from '../../../../../utils/errors';
import { Alert } from '@mui/material';
import FormPreview from '../FormPreview/FormPreview';
import { setCurrentCurriculum } from '../../../../../store/actions/assessment.actions';

const DialogPreview = ({ curriculumId }) => {
  const preview = useSelector((state) => state?.class?.preview || null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const dispatch = useDispatch()

  const onLoad = useCallback(async () => {
    if (preview && !['create', 'edit'].includes(preview)) {
      setLoading(true)
      try {
        const response = await getClassById(curriculumId, preview)
        if (!response?.data && response?.error) {
          setError(response.error.message || 'An error ocurred')
        } else {
          const formData = response?.data || {}
          dispatch(updateClassForm(formData))
          const curriculumid = formData.curriculumId || curriculumId;
          dispatch(setCurrentCurriculum(curriculumid));
        }
      } catch (error) {
        const message = handlerErrorV2(error)
        setError(message)
      } finally {
        setLoading(false)
      }
    }
  }, [curriculumId, preview])

  const onClose = () => {
    dispatch(updateClassPreview())
    dispatch(setCurrentCurriculum(curriculumId));
    if (!['create', 'edit'].includes(preview))  {
      dispatch(updateClassForm({}))
    }
  }

  useEffect(() => {
    onLoad()
  }, [onLoad])

  if (!preview) return <></>

  return (
    <Dialog
      id="class-preview"
      show={!!preview} 
      title="class preview"
      onClose={onClose}
      onCloseHeader={true}
      maxWidth='lg'
    >
      { error ?
        <Alert severity='error'>{error}</Alert>
      : loading 
        ? <ClassSkeleton />
        : <FormPreview />
      }
    </Dialog>
  )
}

export default DialogPreview